<template>
    <div class="hts-navigation">
        <div class="hts-navigation__container">
            <main class="hts-navigation__main">
                <navigation-top
                    :menu-items="topMenuItems"
                    :hidden-user-menu="hiddenUserMenu"
                    :type-page="typePage"
                    @openMenu="openMenu" />

                <div class="flex-1 flex overflow-hidden">
                    <aside
                        v-if="menuItems.length > 0"
                        ref="refMenuUser"
                        class="hts-navigation__aside w-[256px]"
                        :class="{ 'max-w-[256px]': CWAside, 'max-w-[48px]': !CWAside, 'hts-navigation__aside-mobile': mobileMenuOpen }">
                        <navigation-menu :menu-items="menuItems" />
                    </aside>

                    <section class="hts-navigation__section">
                        <hts-tabs
                            v-if="tabs && tabs.length"
                            class="p-4 box-border"
                            :items="tabs"
                            color="main" />

                        <div class="hts-navigation__section-overlay">
                            <div class="p-4 box-border h-full">
                                <slot />
                            </div>
                        </div>
                    </section>
                </div>
            </main>
        </div>
    </div>
</template>

<script lang="ts" setup>
import NavigationMenu from './navigation-menu.vue'
import NavigationTop from './navigation-top.vue'

const tabs = ref([])
const store = $store()

const avatar = computed(() => {
  return store.userConfig.getAvatar
})

const CWAside = computed(() => {
  if (!store.system.miniVariant) {
    return true
  }

  return false
})

const props = defineProps({
  menuItems: {
    type: Array,
    required: true
  },
  topMenuItems: {
    type: Array,
    required: true
  },
  hiddenUserMenu: Boolean,
  hiddenNotifications: {
    type: Boolean,
    default: false
  },
  adminNotification: {
    type: Boolean,
    default: false
  },
  typePage: {
    type: String,
    default: 'ws' // ws | admin | user
  }
})
const { menuItems, topMenuItems, hiddenUserMenu } = toRefs(props)
const route = useRoute()
onMounted(() => {
  nextTick(() => {
    if (route.meta && route.meta.pageTabs) {
      tabs.value = route.meta.pageTabs as []
    }
  })
})
watch(
  () => route.meta.pageTabs,
  (newVal: any, prev: any) => {
    nextTick(() => {
      if (newVal) {
        tabs.value = newVal
      } else {
        tabs.value = []
      }
    })
  }
)

const mode = useColorMode({
  emitAuto: true,
  modes: {
    contrast: 'dark'
  }
})

const { next } = useCycleList(['dark', 'light'], { initialValue: mode })

const changeMode = () => {
  next()
}
// const store = $store()
const user = {
  name: 'Emily Selman',
  imageUrl: `https://images.unsplash.com/photo-1502685104226-ee32379fefbe?ixlib=
    rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=
    2&w=256&h=256&q=80`
}

const mobileMenuOpen = ref(false)

/**
 *  Handle click menu user
 */
const isMenuUser = ref(false)
const refMenuUser = ref(null)
const refImgMenuUser = ref(null)

const setIsMenuUser = () => {
  isMenuUser.value = !isMenuUser.value
}

const { isOutside } = useMouseInElement(refImgMenuUser)

onClickOutside(refMenuUser, () => {
  mobileMenuOpen.value = false
})

const openMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}
</script>
